import { render, staticRenderFns } from "./NewsViewBy.vue?vue&type=template&id=7d8cf68c"
import script from "./NewsViewBy.vue?vue&type=script&lang=js"
export * from "./NewsViewBy.vue?vue&type=script&lang=js"
import style0 from "./NewsViewBy.vue?vue&type=style&index=0&id=7d8cf68c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports